export function isRecurrenceAuthorized(recurrence) {
  if (recurrence == null) {
    return false
  }

  const authorization = recurrence.is_authorized

  return authorization === true || authorization === 1 || authorization === "1"
}
